/* Constants for layout */
export const HEADER_HEIGHT = "60px";
export const HEADER_ELEMENT_HEIGHT = "40px";
export const SIDEBAR_WIDTH = "200px";
export const NAVBAR_ICON_SIZE = 18;
export const NAVBAR_TEXT_SIZE = "14px";
export const NESTED_NAVBAR_TEXT_SIZE = "12px";
export const AUTHENTICATED_FOOTER_HEIGHT = "125px"; // 60 + 65px
